import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionFaxProfiles extends Layout {
    sourceRenditionFaxProfiles: DataSource;
    textbox10: Textbox;
    textbox11: Textbox;
    textbox12: Textbox;
    textbox13: Textbox;
    textbox14: Textbox;
    textbox15: Textbox;
    textbox1: Textbox;
    textbox2: Textbox;
    textbox3: Textbox;
    textbox4: Textbox;
    textbox5: Textbox;
    textbox6: Textbox;
    textbox7: Textbox;
    textbox8: Textbox;
    textbox9: Textbox;
}
